import React, { useContext } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getAmountInCent, getConfiguration, getLocaleDotRound, getPrintableAmount, getValidAmountString, selectInputText, getUkCombinationName, isUKCombinationMaskEnabled, additionalUkTuplesRules } from '../../data/utils';
import { getLabel } from '../../InitData';

function SystemTuples(props) {
	const betslipContext = useContext(BetslipContext) ;
    let betslipData = betslipContext.getBetslipData();
    let conf = getConfiguration();
	let mult = conf.cs.m;
	let charDecimalBrowser = getLocaleDotRound().round;
	const couponKey = props.couponKey;
	const container = props.container;

	
	const coupon = betslipData.coupons[couponKey];
    
    let idBetOnAll = "bet-on-all-coupon-" + couponKey  + "-container-" + container;
    
    let userSystemSelections = coupon.userSystemSelections;
    let combinations = coupon.calculatedSystemData.comb;
   
    if(combinations == null){
    	combinations = [];
    }
    
    function getFormattedAmount(centAmount){
    	return getPrintableAmount(centAmount, conf.cs.m, conf.cs.nd);
    }
    
    function toggleCombs(indexComb){
    	userSystemSelections[indexComb].selected = !userSystemSelections[indexComb].selected;
    	if(coupon.betOnAllEnabled){
    		coupon.betOnAllEnabled = false;
    	}
      	if(userSystemSelections[indexComb].selected && userSystemSelections[indexComb].amount === 0){
      		// restore the minimum
      		const amountCentToSet = betslipContext.minimumCombAmount;
      		userSystemSelections[indexComb].printableAmount = getFormattedAmount(amountCentToSet);
      		userSystemSelections[indexComb].amount = amountCentToSet;
      	}
    	coupon.printableSplitAmount = 0;
    	if(isUKCombinationMaskEnabled() && userSystemSelections[indexComb].selected){
    		if(indexComb > 30 ){
    			// it is an additional tuple. I deactivate the original ones that compose this one.
    			const additionalTupleRule = additionalUkTuplesRules[indexComb];
    			for(let isttc in additionalTupleRule.indexesToTakeCombs){
    				let originalIndex = additionalTupleRule.indexesToTakeCombs[isttc];
    				if(originalIndex === 'all_valued'){
    					// deactivate all the original tuples and the other additional ones
    					for(let i in userSystemSelections){
    						if(i != indexComb){
	    						userSystemSelections[i].selected = false;    						
    						}
    					}
    				}
    				else {
    					// deactivate all the other additional tuples, and the original ones composing this specific tuple
    					const totalSize = additionalUkTuplesRules.getTotalTuplesToAddInList() + 30;
    					for(let i = 31; i < totalSize; i++){
    						if(i != indexComb && userSystemSelections[i]){
	    						userSystemSelections[i].selected = false;    						
    						}
    					}
    					// just this one
    					userSystemSelections[originalIndex].selected = false;
    				}
    			}
    		}
    		else{
    			const indexesOfAdditionalTuplesToUnselect = additionalUkTuplesRules.getListOfAdditionalTuplesByOriginalTupleIndex(indexComb);
    			for(let ki in indexesOfAdditionalTuplesToUnselect){
    				const additionalTupleIndex = indexesOfAdditionalTuplesToUnselect[ki];
   					if(userSystemSelections[additionalTupleIndex]){
	    				userSystemSelections[additionalTupleIndex].selected = false;   					
   					}
    			}
    		}
    	}
    	betslipContext.setBetslipData(betslipData, true);
    }
    
    function toggleBetOnAll(){
    	coupon.betOnAllEnabled = !coupon.betOnAllEnabled;
    	if(coupon.betOnAllEnabled == false){
    		// I disable all the combs: I can't do it in the BetslipConf because there is  no chance to know
    		// if the bet on all is just disabled or has been requested from the user to deactivate everything
    		for(let k in userSystemSelections){
    			userSystemSelections[k].selected = false;
    		}
    		
    	}
    	betslipContext.setBetslipData(betslipData, true);
    }
    
    function setAmountBetOnAll(settedAmount){
 	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
 	   settedAmount = getValidAmountString(settedAmount);
 	   // putting the "browser decimal dot" instead of the "." for the float type
 	   let fieldTextValue = settedAmount;
 	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
 	   let amountCentToSet = coupon.betOnAll; // last valid amount
 	   
 	   // if is number, I calculate the new amount and I keep it into the field value. 
 	   // If not, I keep the field but I use the last valid amount for the calcs
 	   if (isNaN(settedAmount) === false && settedAmount.length > 0) {
 		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
 	   }
 	   
 	   coupon.printableBetOnAll = fieldTextValue;
 	   coupon.betOnAll = amountCentToSet;
 	   betslipContext.setBetslipData(betslipData, true);
 	}
    
    function setAmountCombs(indexCombs, settedAmount){
    	coupon.betOnAllEnabled = false; // deactivate bet on all
    	
    	// get a valid input field value for this amount: only number and dot, and max nDec digit after it
  	   settedAmount = getValidAmountString(settedAmount);
  	   // putting the "browser decimal dot" instead of the "." for the float type
  	   let fieldTextValue = settedAmount;
  	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
  	   let amountCentToSet = userSystemSelections[indexCombs].amount; // last valid amount
  	   
  	   // if is number, I calculate the new amount and I keep it into the field value. 
  	   // If not, I keep the field but I use the last valid amount for the calcs
  	   if (isNaN(settedAmount) === false && settedAmount.length > 0) {
  		   amountCentToSet = getAmountInCent(parseFloat(settedAmount), mult);
  	   }
  	   
  	   userSystemSelections[indexCombs].printableAmount = fieldTextValue;
  	   userSystemSelections[indexCombs].amount = amountCentToSet;
  	   betslipContext.setBetslipData(betslipData, true);
    }
    
    function increaseCombsAmount(sign, indexCombs){
    	
   	   	
    	let amountCentToSet = userSystemSelections[indexCombs].amount; // last valid amount
    	const increment = sign * betslipContext.minimumCombAmount;
    	let okEdit = false;
    	amountCentToSet += increment;
    	if(increment > 0){
    		okEdit = true;
    	}
    	else if(increment < 0){
    		// checking if the new value is greater or equal to the minimum amount configured for the combinations 
    		okEdit = amountCentToSet >= betslipContext.minimumCombAmount;
    	}
    	
    	if(okEdit){
    		coupon.betOnAllEnabled = false; // deactivate bet on all
    		userSystemSelections[indexCombs].selected = true;
    		userSystemSelections[indexCombs].printableAmount = getFormattedAmount(amountCentToSet);
    		userSystemSelections[indexCombs].amount = amountCentToSet;
    		betslipContext.setBetslipData(betslipData, true);
    	}
    }
    
    function splitAmountCombs(amount){
    	// get a valid input field value for this amount: only number and dot, and max nDec digit after it
    	amount = getValidAmountString(amount);
   	   // putting the "browser decimal dot" instead of the "." for the float type
   	   let fieldTextValue = amount;
   	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);
   	   
   	   let amountCentToSet = 0;
   	   // if is number, I calculate the new amount and I keep it into the field value. 
   	   // If not, I keep the field but I use the last valid amount for the calcs
   	   if (isNaN(amount) === false && amount.length > 0) {
   		   amountCentToSet = getAmountInCent(parseFloat(amount), mult);
   		   let totalCombsSelected = 0;
		   for(let ks in userSystemSelections){
			   if(userSystemSelections[ks].selected){
				   if(combinations[ks] != null){
					   totalCombsSelected += combinations[ks];
				   }
			   }
		   }
		   if(totalCombsSelected > 0){
			   let valuePerTuple = amountCentToSet / totalCombsSelected;
			   valuePerTuple = parseInt(Math.ceil(valuePerTuple));
			   let module = valuePerTuple % betslipContext.minimumCombAmount;
			   if(valuePerTuple < betslipContext.minimumCombAmount ){
				   valuePerTuple = betslipContext.minimumCombAmount;				   
			   }
			   else if(module != 0){
				  const rest = (valuePerTuple / betslipContext.minimumCombAmount) % 1 === 0? 0 : (valuePerTuple % betslipContext.minimumCombAmount);
				  valuePerTuple  = valuePerTuple - rest;
				  valuePerTuple = parseInt(valuePerTuple);
				  if(valuePerTuple < betslipContext.minimumCombAmount){
					  valuePerTuple = betslipContext.minimumCombAmount;
				  }  
			   }
			   for(let ks in userSystemSelections){
				   if(userSystemSelections[ks].selected){
					   userSystemSelections[ks].printableAmount = getFormattedAmount(valuePerTuple);
					   userSystemSelections[ks].amount = valuePerTuple;
				   }
			   }   
 		   }
		   
   	   }
   	   coupon.printableSplitAmount = fieldTextValue;
   	   betslipContext.setBetslipData(betslipData, true);
    }
    
    
    let atLeastOneTuple = false;
    for(let ks in userSystemSelections){
    	atLeastOneTuple = atLeastOneTuple || userSystemSelections[ks].selected;
    	if(atLeastOneTuple){
    		break;
    	}
    }
    
  

    // const stakeTaxedForPurchase = betslipContext.stakeTaxConfiguration.enabled && 
	//   							  betslipContext.stakeTaxConfiguration.type === 'conf_for_purchase';
	
	const ukCombinationMask = isUKCombinationMaskEnabled();
	
	let accumulatorCombination = null;
	if(ukCombinationMask && combinations[coupon.totalDraws] == 1){
		accumulatorCombination = {
			comb : combinations[coupon.totalDraws],
			index : coupon.totalDraws
		};
	}
    
    return (
    	<div className="evento-schedina">
            <div className="schedina-scomm-checker">
                {
                	!ukCombinationMask && <>
		                <div className="custom-control custom-checkbox">
		                    <input checked={coupon.betOnAllEnabled} 
		                     	   type="checkbox" 
		                     	   className="custom-control-input" id={idBetOnAll + '-checkbox'} 
		                    	   onChange={(e) => toggleBetOnAll()} />
		                    <label className="custom-control-label pointer" htmlFor={idBetOnAll + '-checkbox'}>{getLabel('carrello.system_bets.bet_on_all')}</label>
		                </div>
		               <input className="input-personalizzato" 
                	   	      type="text" 
                	   	      id={idBetOnAll + '-amount-text'}
                	   		  value={coupon.printableBetOnAll}
                	          readOnly={!coupon.betOnAllEnabled}
                	   		  onChange={(e) => setAmountBetOnAll(e.target.value + "")}
                       		  onFocus={selectInputText}/> 
		            </>
                }

            </div>
	        {/*[COMBINATIONS TABLE ]*/}
	        <div className="tabella-puntate-sistema testo-piccolo">
		        <div className="titolo-tps bg-grigio-chiaro titolo-tps-grp">{getLabel('carrello.system_bets.grp')}</div>
		        <div className="titolo-tps bg-grigio-chiaro titolo-tps-check"></div>
		        <div className="titolo-tps bg-grigio-chiaro titolo-tps-systemBets">{getLabel('carrello.system_bets.com')}</div>
		        <div className="titolo-tps bg-grigio-chiaro titolo-tps-amount">{getLabel('carrello.system_bets.amount')}</div>
		        <div className="titolo-tps bg-grigio-chiaro titolo-tps-winnings">{getLabel('carrello.system_bets.winnings')}</div>
		        {/* ACCUMULATOR GOES FIRST */}
		        {
		        	ukCombinationMask && accumulatorCombination && <React.Fragment key={"accumulator"}>
		        		<div className="campo-tps">{getUkCombinationName(accumulatorCombination.index, true)}</div>
        				<div className="campo-tps">
	        				<div className="custom-control custom-checkbox">
	        					<input checked={userSystemSelections[accumulatorCombination.index].selected} 
	        						   onChange={(e) => toggleCombs(accumulatorCombination.index)} 
	        						   type="checkbox" className="custom-control-input" id={"accumulator-input"} />
	        					<label className="custom-control-label pointer" htmlFor={"accumulator-input"}></label>
	        				</div>
        				</div>
		        		<div className="campo-tps">1x</div>
        				<div className="campo-tps">
        					<div className="caretContainer">
        						<i className="fa fa-caret-down" onClick={() => {increaseCombsAmount(-1,accumulatorCombination.index)}}> </i>
        					</div>
        					<input className="input-personalizzato" 
        						type="text" 
        						id={"accumulator-amount-text"} 
        						value={userSystemSelections[accumulatorCombination.index].printableAmount}
        						readOnly={!userSystemSelections[accumulatorCombination.index].selected}
        						onChange={(e) => setAmountCombs(accumulatorCombination.index, e.target.value + "")}
                                onFocus={selectInputText}
        					/>
        					<div className="caretContainer" onClick={() => {increaseCombsAmount(1, accumulatorCombination.index)}}>
    							<i className="fa fa-caret-up"> </i>
    						</div>
        				</div>
        				<div className="campo-tps"> 
        					{getFormattedAmount(userSystemSelections[accumulatorCombination.index].vMin)} 
        					<br/> 
        					{getFormattedAmount(userSystemSelections[accumulatorCombination.index].vMax)}
        				</div>
		        	</React.Fragment>
		        }
		        
		        {combinations.map(function(combination, index){
		        		const isAccumulator = index == coupon.totalDraws;
		        		const skipAccumulator = ukCombinationMask && isAccumulator && accumulatorCombination != null;
		        		if(combination > 0 && ! skipAccumulator){
		        			let reactCombKey = 'system-tuples-coupon-' + couponKey + '-container-' + container + "-tuple-" + index;
		        			let idInputCheckbox = reactCombKey + "-checkbox";
		        			let idInputText = reactCombKey + "-amount-text";
		        			return <React.Fragment key={reactCombKey}>
		        				<div className="campo-tps">{ukCombinationMask? getUkCombinationName(index, isAccumulator) : index}</div>
		        				<div className="campo-tps">
			        				<div className="custom-control custom-checkbox">
			        					<input checked={userSystemSelections[index].selected} onChange={(e) => toggleCombs(index)} type="checkbox" className="custom-control-input" id={idInputCheckbox} />
			        					<label className="custom-control-label pointer"htmlFor={idInputCheckbox}></label>
			        				</div>
		        				</div>
		        				<div className="campo-tps">{combination}{ukCombinationMask? 'x' : ''}</div>
		        				<div className="campo-tps">
		        					<div className="caretContainer">
		        						<i className="fa fa-caret-down" onClick={() => {increaseCombsAmount(-1,index)}}> </i>
		        					</div>
		        					<input className="input-personalizzato" 
		        						type="text" 
		        						id={idInputText} 
		        						value={userSystemSelections[index].printableAmount}
		        						readOnly={!userSystemSelections[index].selected}
		        						onChange={(e) => setAmountCombs(index, e.target.value + "")}
                                        onFocus={selectInputText}
		        					/>
		        					<div className="caretContainer" onClick={() => {increaseCombsAmount(1, index)}}>
	        							<i className="fa fa-caret-up"> </i>
	        						</div>
		        				</div>


		        				<div className="campo-tps vincite"> 
		        					{getFormattedAmount(userSystemSelections[index].vMin)} 
		        					<br/> 
		        					{getFormattedAmount(userSystemSelections[index].vMax)}
 
		        				</div>
		        				
		        			</React.Fragment>
		        		}
		        		return null;
		        	})
		        }	        
	        </div>
	        {
	        	!ukCombinationMask && 
	        	<div className="schedina-suddividi-puntata">
	         		<div className="schedina-suddividi-puntata-testo">
	             		<p>{getLabel('carrello.system_bets.split_bet')}</p> 
	         		</div>
	         		<input value={coupon.printableSplitAmount} onChange={(e) => splitAmountCombs(e.target.value + "")} onFocus={selectInputText} readOnly={!atLeastOneTuple} className="input-personalizzato" type="text" id="input-tps-3" />
	       		</div>
	        }

	  </div>
    );
}

export default SystemTuples;